import { cloneDeep } from 'lodash';
import { ONBOARDING_FLOWS, ONBOARDING_INITIAL_TASKS, STEPS_CONFIG } from './onboarding.config';

export default {
  namespaced: true,
  state: {
    activeStepId: null,
    analyticType: null,
    currentOnboardingFlowKey: null,
    projectData: {
      name: null,
      tasks: cloneDeep(ONBOARDING_INITIAL_TASKS),
      teammates: [{ email: '' }, { email: '' }, { email: '' }],
    },
  },
  getters: {
    isRegistrationViaSocials(state) {
      return ['OWNER_SOCIAL_NETWORKS', 'TEAM_MEMBER_SOCIAL_NETWORKS'].includes(state.currentOnboardingFlowKey);
    },
    /**
     * Get current step configuration with fallback logic
     * Finds step config by activeStepId, with automatic fallback to next available step
     * if current step is disabled or not found in STEPS_CONFIG
     */
    getCurrentStepConfig(state, getters) {
      if (!state.activeStepId) {
        return null;
      }
      
      const currentStep = STEPS_CONFIG.find(step => step.id === state.activeStepId);
      
      if (currentStep) {
        return currentStep;
      }
      
      // Step not found - try to find fallback step
      const stepsOrder = getters.getCurrentStepsOrder;
      const currentIndex = stepsOrder.findIndex(stepId => stepId === state.activeStepId);
      
      let fallbackStepId = null;
      
      if (currentIndex >= 0 && currentIndex + 1 < stepsOrder.length) {
        // Try next step in order
        fallbackStepId = stepsOrder[currentIndex + 1];
      } else {
        // Fallback to second step (index 1) or first step
        fallbackStepId = stepsOrder[1] || stepsOrder[0];
      }
      
      if (fallbackStepId) {
        const fallbackStep = STEPS_CONFIG.find(step => step.id === fallbackStepId);
        if (fallbackStep) {
          // Update activeStepId and save state
          this.commit('onboarding/setActiveStepId', fallbackStepId);
          this.dispatch('user/updateActivitySettings', {
            activityName: 'onboarding',
            settings: { lastActiveStep: fallbackStepId },
          }, { root: true });
          return fallbackStep;
        }
      }
      
      return null;
    },
    getProjectTasks(state) {
      return state.projectData.tasks;
    },
    getTeammates(state) {
      return state.projectData.teammates;
    },
    getCurrentOnboardingFlow(state) {
      return ONBOARDING_FLOWS[state.currentOnboardingFlowKey];
    },
    /**
     * Get steps order for current onboarding flow
     * Returns array of step IDs in the order they should be executed
     */
    getCurrentStepsOrder(state, getters) {
      return getters.getCurrentOnboardingFlow.stepsOrder;
    },
    getProjectName(state) {
      return state.projectData.name;
    },
    getCurrentStepIndex(state, getters) {
      return getters.getCurrentStepsOrder.findIndex(item => item === state.activeStepId);
    },
    getNextStepId(state, getters) {
      const nextStepIndex = getters.getCurrentStepIndex + 1;

      return getters.getCurrentStepsOrder[nextStepIndex] || null;
    },
  },
  actions: {
    async nextStep({ getters, commit, dispatch }) {
      const nextStepId = getters.getNextStepId;

      if (nextStepId) {
        await dispatch(
          'user/updateActivitySettings',
          { activityName: 'onboarding', settings: { lastActiveStep: nextStepId }},
          { root: true },
        );
        commit('setActiveStepId', nextStepId);

        return Promise.resolve();
      }

      return Promise.reject('Cannot find onboarding nextStepId');
    },
    async finish({ dispatch }) {
      return dispatch(
        'user/updateActivitySettings',
        { activityName: 'onboarding', settings: { isFinished: true } },
        { root: true },
      );
    },
  },
  mutations: {
    setCurrentOnboardingFlowKey(state, value) {
      state.currentOnboardingFlowKey = value;
    },
    setActiveStepId(state, value) {
      state.activeStepId = value;
    },
    updateTask(state, { value, index }) {
      Object.assign(state.projectData.tasks[index], { name: value });
    },
    updateProjectName(state, value) {
      state.projectData.name = value;
    },
    setAnalyticType(state, value) {
      state.analyticType = value;
    },
  },

};
